import Logo from './Logo'
import Helps from './Helps'
import Logout from './Logout'
import Menu from './Menu'
import FastNavigationBar from '../FastNavigationBar'
import { Button } from '@/components/ui/button'
import { X } from 'lucide-react'

interface SidebarProps {
  onClose?: () => void
}

export default function SideBar({ onClose }: SidebarProps) {
  return (
    <aside className="w-64 bg-white h-full flex flex-col py-4 border-r border-gray-200">
      {/* 移動端關閉按鈕 */}
      {onClose && (
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 md:hidden">
          <div className="flex items-center">
            <img src="/images/xlogo.png" alt="logo" className="h-8 w-auto" />
          </div>
          <Button variant="ghost" size="sm" onClick={onClose} className="p-2">
            <X className="h-5 w-5" />
          </Button>
        </div>
      )}

      <FastNavigationBar variant="mobile" onNavigate={onClose} />

      {/* Logo - 只在桌面端或沒有 onClose 時顯示 */}
      <div className={onClose ? 'hidden md:block md:pt-12' : 'pt-12'}>
        <Logo />
      </div>
      <Menu onClose={onClose} />
      <div className="mt-auto">
        {' '}
        {/* Pushes Helps and Logout to the bottom */}
        <Helps />
        <Logout />
      </div>
    </aside>
  )
}
